import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  image: string;
  alt: string;
  rating: number;
  review: string;
  language: string;
}

const testimonials: Testimonial[] = [
{
  id: 1,
  name: 'Priya Sharma',
  location: 'Mumbai, Maharashtra',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_111e29bbe-1763294966477.png",
  alt: 'Young Indian woman with long black hair wearing traditional red kurta smiling warmly at camera',
  rating: 5,
  review: 'StoryNest-FM has become my daily companion during commutes. The Hindi story collection is amazing, and the offline feature is a lifesaver!',
  language: 'Hindi Stories'
},
{
  id: 2,
  name: 'Rajesh Kumar',
  location: 'Bangalore, Karnataka',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee845b54-1763296778511.png",
  alt: 'Professional Indian man in navy blue shirt with short black hair and glasses looking confident',
  rating: 5,
  review: 'The app quality is exceptional. I love how I can switch between Kannada and English stories seamlessly. Best audio app I have used!',
  language: 'Kannada & English'
},
{
  id: 3,
  name: 'Anjali Patel',
  location: 'Ahmedabad, Gujarat',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19ddb3ca6-1763300632835.png",
  alt: 'Young Indian woman with shoulder-length brown hair in white blouse smiling brightly outdoors',
  rating: 5,
  review: 'As a Gujarati content lover, finding quality regional stories was difficult until I discovered StoryNest-FM. The variety is incredible!',
  language: 'Gujarati Stories'
},
{
  id: 4,
  name: 'Arjun Reddy',
  location: 'Hyderabad, Telangana',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf8f2d50-1763295612500.png",
  alt: 'Indian man with short black hair wearing casual grey t-shirt with friendly smile',
  rating: 5,
  review: 'The Telugu thriller collection is outstanding! Audio quality is crystal clear, and the recommendations are spot-on. Worth every rupee!',
  language: 'Telugu Thrillers'
},
{
  id: 5,
  name: 'Meera Iyer',
  location: 'Chennai, Tamil Nadu',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_111e29bbe-1763294966477.png",
  alt: 'South Indian woman with long black hair in traditional green saree with warm smile',
  rating: 5,
  review: 'Finally, an app that celebrates Tamil literature! The narration quality is superb, and I love the sleep timer feature for bedtime stories.',
  language: 'Tamil Literature'
},
{
  id: 6,
  name: 'Vikram Singh',
  location: 'Delhi, NCR',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1292be1e7-1763295448730.png",
  alt: 'North Indian man with beard wearing white kurta and turban with confident expression',
  rating: 5,
  review: 'The premium membership is totally worth it! Ad-free listening and exclusive content make my daily workout sessions so much better.',
  language: 'Premium Member'
}];


export default function UserTestimonials() {
  return (
    <section className="py-20 bg-gradient-to-br from-secondary/5 to-primary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-4">
            Loved by Millions<br />
            <span className="text-primary">Across India</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Join our community of passionate story listeners and discover why they choose StoryNest-FM
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-card p-6 rounded-2xl border border-border hover:border-primary transition-all duration-300 hover:shadow-warm-lg hover:-translate-y-1">

              <div className="flex items-center space-x-4 mb-4">
                <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-lg font-heading font-bold text-text-primary truncate">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-text-secondary truncate">{testimonial.location}</p>
                  <div className="flex items-center space-x-1 mt-1">
                    {[...Array(testimonial.rating)].map((_, i) =>
                  <Icon
                    key={i}
                    name="StarIcon"
                    size={16}
                    variant="solid"
                    className="text-accent" />

                  )}
                  </div>
                </div>
              </div>

              <p className="text-text-secondary leading-relaxed mb-4">
                "{testimonial.review}"
              </p>

              <div className="flex items-center space-x-2 text-sm">
                <Icon name="LanguageIcon" size={16} className="text-primary" />
                <span className="text-primary font-semibold">{testimonial.language}</span>
              </div>
            </div>
          )}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-card px-8 py-6 rounded-2xl shadow-warm-lg">
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-primary">4.8</div>
              <div className="flex items-center justify-center space-x-1 mt-1">
                {[...Array(5)].map((_, i) =>
                <Icon
                  key={i}
                  name="StarIcon"
                  size={16}
                  variant="solid"
                  className="text-accent" />

                )}
              </div>
              <div className="text-sm text-text-secondary mt-1">App Rating</div>
            </div>

            <div className="w-px h-12 bg-border" />

            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-secondary">5M+</div>
              <div className="text-sm text-text-secondary mt-1">Downloads</div>
            </div>

            <div className="w-px h-12 bg-border" />

            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-success">2M+</div>
              <div className="text-sm text-text-secondary mt-1">Active Users</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}